import { Component, OnInit } from '@angular/core';

import { Form, FormMode } from '../../../base/form';
import { FormGroup } from '@angular/forms';
import { blank, filled } from '../../../shared/utils/common';
import { NotificationService } from '../../../services/notification.service';
import { LooseObject } from '../../../objects/loose-object';
import { get, isArray } from 'lodash-es';

@Component({
  selector: 'app-contract-items',
  templateUrl: './contract-items.component.html',
  styleUrls: ['./contract-items.component.scss']
})
export class ContractItemsComponent implements OnInit {

  strMode: string = 'view';

  objParentForm: FormGroup;

  arLineItems: ContractLineItem[] = [];

  arExistingLineItems: ContractLineItem[] = [];

  get displayForm(): boolean {
    return this.strMode == 'edit' || this.strMode == 'add';
  }

  get isEdit(): boolean {
    return this.strMode == 'edit';
  }

  get isView(): boolean {
    return this.strMode == 'view';
  }

  get displayList(): boolean {
    return this.strMode == 'edit' || this.strMode == 'view';
  }

  constructor(
    private notificationService: NotificationService,
  ) { }

  ngOnInit() { }

  /**
   * @inheritdoc
   */
  setFormMode(mode: FormMode): void {
    this.strMode = mode;
  }

  /**
   * @inheritdoc
   */
  setParentForm(parentForm: FormGroup): void {
    this.objParentForm = parentForm;
    if (filled(parentForm.controls['contract_items'].value)) {
      this.arLineItems = parentForm.controls['contract_items'].value.map( data => new ContractLineItem(data));
    }
  }

  /**
   * @inheritdoc
   */
  setField(field: Form<any>): void {
    if (filled(get(field, 'default_value'))) {
      this.arExistingLineItems = get(field, 'default_value').map( data => new ContractLineItem(data));
    }
  }

  /**
   * add new line item
   *
   * @param lineItem
   */
  addLineItem(lineItem: LooseObject = {}): void {
    const itemId = get(lineItem, 'id');
    let objExistingLineItem = this.arLineItems.find(item => item.item_id == itemId);
    if (blank(objExistingLineItem)) {
      this.arLineItems.push(
        new ContractLineItem({
          name: get(lineItem, 'name'),
          description: get(lineItem, 'description'),
          contract_unit_price: get(lineItem, 'unit_price', 0),
          item_id: itemId,
          item_code: get(lineItem, 'code', 0),
          item_unit_cost: get(lineItem, 'unit_cost', 0),
          item_unit_price: get(lineItem, 'unit_price', 0),
          action: 'create',
        })
      );
      this._syncRecord();
    } else {
      this.notificationService.notifyWarning('add_line_item_already_exist');
    }
  }

  /**
   * on change unit price
   *
   * @param lineItem
   */
  onChangeUnitPrice(lineItem: ContractLineItem): void {
    if (filled(lineItem.id)) {
      lineItem.action = 'update';
    }
    this._syncRecord();
  }

  /**
   * remove the line item, if the line item is existing, add value to the action as deleted
   *
   * @param lineItem
   * @param index
   */
  removeLineItem(lineItem: ContractLineItem, index: number): void {
    if (filled(lineItem.id)) {
      lineItem.action = 'delete';
    } else {
      this.arLineItems.splice(index, 1);
    }
    this._syncRecord();
  }

  /**
   * sync the record to parent form
   */
  private _syncRecord(): void {
    if (this.objParentForm) {
      this.objParentForm.controls.contract_items.setValue(this.arLineItems);
    }
  }
}

export class ContractLineItem {

  id?: string;
  name?: string;
  description?: string;
  contract_unit_price?: number;
  item_id?: string;
  item_code?: string;
  item_unit_cost?: number;
  item_unit_price?: number;
  action?: string;

  constructor(prop: LooseObject){
    this.id = prop.id;
    this.name = prop.name;
    this.description = prop.description;
    this.contract_unit_price = prop.contract_unit_price || 0;
    this.item_id = prop.item_id;
    this.item_code = prop.item_code;
    this.item_unit_cost = prop.item_unit_cost || 0;
    this.item_unit_price = prop.item_unit_price || 0;
  }
}